export class CommentsChangeNotification {
	public viewId: number;
	public folderId: string;
	public documentId: string;

	public static fromJson(other: any): CommentsChangeNotification {
		const instance = new CommentsChangeNotification();
		instance.viewId = other.ViewId;
		instance.folderId = other.FolderId;
		instance.documentId = other.DocumentId;
		return instance;
	}
}
